import { Api } from "@/api"
import { LoggedInUser, SystemRole } from "@/models"
import { toReactive } from "@vueuse/core"
import { defineStore } from "pinia"
import { computed, type ComputedRef, reactive, toRef } from "vue"
import { defineGlobals, ensureLoadingHasResult, piniaLoadableState } from "vue-utils"

async function getAccount(): Promise<LoggedInUser> {
	const user = await Api.users.getAccount()
	return reactive(new LoggedInUser(user))
}

export const useLoggedInUserStore = defineStore("logged-in-user", {
	state: () => piniaLoadableState(getAccount),
})

export function useLoggedInUser(): LoggedInUser {
	const store = useLoggedInUserStore()
	return toReactive(toRef(() => ensureLoadingHasResult(store)))
}

export function useAtLeastHasRole(role: SystemRole): ComputedRef<boolean> {
	const user = useLoggedInUser()
	return computed(() => user.atLeastHasRole(role))
}

defineGlobals({
	useLoggedInUser,
	useLoggedInUserStore,
})
